<script setup lang="ts">
  import { useProductList } from '@/models/product'

  const { getData, loading, products, pagination } = useProductList()

  getData({
    page: '1',
    per_page: '10',
    price: 'unset',
  })
</script>

<template>
  <app-card
    icon="i-far-boxes-stacked"
    title="Produk Belum Memiliki Harga Jual">
    <app-table>
      <thead>
        <tr>
          <th class="w-px text-right">
            #
          </th>
          <th class="w-px text-left">
            Kode
          </th>
          <th class="text-left">
            Nama
          </th>
          <th class="text-left">
            Grup
          </th>
          <th class="text-left">
            Supplier
          </th>
          <!-- <th class="text-left">
            Tanggal Daftar
          </th> -->
        </tr>
      </thead>
      <tbody>
        <template v-if="loading">
          <tr
            v-for="i in 5"
            :key="`skeleton-${i}`">
            <td>
              <div class="loading h-5 w-5"></div>
            </td>
            <td>
              <div class="loading h-5 w-16"></div>
            </td>
            <td>
              <div class="loading h-5 w-48"></div>
            </td>
            <td>
              <div class="loading h-5 w-24"></div>
            </td>
            <td>
              <div class="loading h-5 w-32"></div>
            </td>
          </tr>
        </template>
        <tr
          v-for="(product, i) in products"
          v-show="!loading"
          :key="product.id">
          <td class="text-right">
            {{ (pagination?.from ?? 0)+ i }}.
          </td>
          <td class="whitespace-nowrap">
            {{ product.code }}
          </td>
          <td>
            {{ product.name }}
          </td>
          <td>{{ product.product_group?.name }}</td>
          <td>{{ product.supplier?.name }}</td>
          <!-- <td :title="fmt.date(product.created_at)">
            {{ fmt.dateRelative(product.created_at) }}
          </td> -->
        </tr>
        <tr v-if="products.length === 0 && !loading">
          <td
            colspan="9"
            class="h-48 text-center">
            <fa-icon
              class="text-6xl mb-4"
              icon="i-fat-thumbs-up" />
            <div class="text-2xl font-bold mb-2">
              All set!
            </div>
            <div class="text-gray-500">
              Semua produk siap dijual
            </div>
          </td>
        </tr>
        <tr v-if="(pagination?.total ?? 0) > (pagination?.per_page ?? 0) && !loading">
          <td colspan="9">
            <app-button
              class="btn-link"
              :to="{name: 'product list'}">
              Lihat semua ({{ pagination?.total ?? 0 }} produk)
            </app-button>
          </td>
        </tr>
      </tbody>
    </app-table>
  </app-card>
</template>
